<template>
    <Teleport to="body">
        <div v-if="open" class="analytics-drawer-overlay" @click.self="$emit('close')">
            <aside class="analytics-drawer" role="dialog" aria-label="Аналитика">
                <header class="analytics-drawer__header">
                    <h2>Аналитика</h2>
                    <button type="button" class="analytics-drawer__close" aria-label="Закрыть" @click="$emit('close')">
                        ×
                    </button>
                </header>

                <div class="analytics-drawer__tabs">
                    <button
                        v-for="tab in tabs"
                        :key="tab.id"
                        type="button"
                        class="analytics-tab"
                        :class="{ 'analytics-tab--active': activeTab === tab.id }"
                        @click="activeTab = tab.id"
                    >
                        {{ tab.label }}
                    </button>
                </div>

                <div class="analytics-drawer__body">
                    <div v-show="activeTab === 'filters'" class="analytics-panel">
                        <StatsFilters
                            :seasons="seasons"
                            :matches="matches"
                            :filter-data="filterData"
                            :initial-filters="filters"
                            :default-expanded="true"
                            @filter-change="$emit('filter-change', $event)"
                            @export="$emit('export', $event)"
                        />
                    </div>
                    <div v-show="activeTab === 'matches'" class="analytics-panel">
                        <MatchStatsTable :rows="matchRows" :position="position" />
                    </div>
                    <div v-show="activeTab === 'chart'" class="analytics-panel">
                        <StatsCharts :chart-data="chartData" :history-data="chartData" />
                    </div>
                    <div v-show="activeTab === 'dvw'" class="analytics-panel">
                        <DvwLegend />
                        <PlayerStatsBreakdown :stats="stats" />
                    </div>
                </div>
            </aside>
        </div>
    </Teleport>
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted } from 'vue';
import StatsFilters from '@/components/stats/StatsFilters.vue';
import StatsCharts from '@/components/stats/StatsCharts.vue';
import PlayerStatsBreakdown from '@/components/stats/PlayerStatsBreakdown.vue';
import MatchStatsTable from '@/components/stats/MatchStatsTable.vue';
import DvwLegend from '@/components/stats/DvwLegend.vue';

const props = defineProps({
    open: { type: Boolean, default: false },
    seasons: { type: Array, default: () => [] },
    matches: { type: Array, default: () => [] },
    filterData: { type: Object, default: () => ({}) },
    filters: { type: Object, default: () => ({}) },
    stats: { type: Object, default: () => ({}) },
    chartData: { type: Array, default: () => [] },
    matchRows: { type: Array, default: () => [] },
    position: { type: String, default: null },
});

const emit = defineEmits(['close', 'filter-change', 'export']);

const activeTab = ref('filters');
const tabs = [
    { id: 'filters', label: 'Фильтры' },
    { id: 'matches', label: 'Матчи' },
    { id: 'chart', label: 'График' },
    { id: 'dvw', label: 'DVW' },
];

watch(
    () => props.open,
    (isOpen) => {
        if (typeof document === 'undefined') return;
        document.body.style.overflow = isOpen ? 'hidden' : '';
    },
);

const closeOnEscape = (e) => {
    if (e.key === 'Escape' && props.open) {
        emit('close');
    }
};

onMounted(() => {
    if (typeof document === 'undefined') return;
    document.addEventListener('keydown', closeOnEscape);
});

onUnmounted(() => {
    if (typeof document === 'undefined') return;
    document.removeEventListener('keydown', closeOnEscape);
    document.body.style.overflow = '';
});
</script>
